/**
 * Localization Service
 * Every UI text lives in the API's AppLocalizationTexts table. The two read calls are
 * anonymous (the sign-in screen needs texts before anyone signs in); the rest are for the
 * super-admin Texts & Translations screen.
 */
import apiClient from './apiClient'

const baseUrl = '/api/supplier/localization-text'

/** The UI's resource; the API's own messages live under 'Supplier'. */
export const FRONTEND_RESOURCE = 'Frontend'

export default {
  /** [{ cultureName, displayName, isDefault }] */
  async getLanguages() {
    return apiClient.get(`${baseUrl}/languages`).then(r => r.data)
  },

  /** Flat { 'auth.register.title': '…' }, already merged over the default culture. */
  async getTexts(cultureName, resourceName = FRONTEND_RESOURCE) {
    return apiClient.get(`${baseUrl}/texts`, { params: { resourceName, cultureName } }).then(r => r.data)
  },

  async search(params = {}) {
    return apiClient.post(`${baseUrl}/search`, params).then(r => r.data)
  },

  async create(data) {
    return apiClient.post(baseUrl, data).then(r => r.data)
  },

  async update(id, data) {
    return apiClient.put(`${baseUrl}/${id}`, data).then(r => r.data)
  },

  async delete(id) {
    return apiClient.delete(`${baseUrl}/${id}`).then(r => r.data)
  },

  /** Flat { key: value } exactly as stored for one resource and culture. */
  async export(resourceName, cultureName) {
    return apiClient.get(`${baseUrl}/export`, { params: { resourceName, cultureName } }).then(r => r.data)
  },

  /** { resourceName, cultureName, texts: { key: value }, overwrite } → { added, updated, unchanged, skipped } */
  async import(data) {
    return apiClient.post(`${baseUrl}/import`, data).then(r => r.data)
  },

  /** Stores the signed-in user's UI language, so e-mails sent to them use it. */
  async updateMyLanguage(cultureName) {
    return apiClient.put('/api/supplier/user-language/my-language', { cultureName }).then(r => r.data)
  }
}
